import { loadScript } from 'dashboard/helper/DOMHelpers';

const FB_SDK_URL = 'https://connect.facebook.net/en_US/sdk.js';
const FB_SDK_ID = 'facebook-jssdk';

let sdkReadyPromise = null;

function runFBInit() {
  window.FB.init({
    appId: window.rookooConfig.fbAppId,
    xfbml: true,
    version: window.rookooConfig.fbApiVersion,
    status: true,
  });
  window.fbSDKLoaded = true;
  window.FB.AppEvents.logPageView();
}

async function waitForFacebookGlobal(timeoutMs = 10000) {
  const startedAt = Date.now();

  while (!window.FB) {
    if (Date.now() - startedAt > timeoutMs) {
      throw new Error('Facebook SDK failed to load');
    }

    await new Promise(resolve => {
      setTimeout(resolve, 50);
    });
  }
}

export function ensureFacebookSdkReady() {
  if (!sdkReadyPromise) {
    sdkReadyPromise = (async () => {
      window.fbAsyncInit = runFBInit;

      await loadScript(FB_SDK_URL, { id: FB_SDK_ID });
      await waitForFacebookGlobal();

      // Match Facebook.vue: always init before login, even if the SDK was cached.
      runFBInit();
    })().catch(error => {
      sdkReadyPromise = null;
      throw error;
    });
  }

  return sdkReadyPromise;
}

export function primeFacebookSdk() {
  window.fbAsyncInit = runFBInit;
}
